import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UploadOutlinedSvg from "@ant-design/icons-svg/es/asn/UploadOutlined";
import AntdIcon from "../components/AntdIcon";
var UploadOutlined = function UploadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UploadOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UploadOutlined.displayName = 'UploadOutlined';
}
export default /*#__PURE__*/React.forwardRef(UploadOutlined);